import { InjectionToken } from '@angular/core';
import { ExecutableVersionPort } from './executable-version.port';

export const EXECUTABLE_VERSION_PORT = new InjectionToken<ExecutableVersionPort>('EXECUTABLE_VERSION_PORT');
